import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    headIconWrapper: {
        textAlign: 'center',
        marginBottom: theme.spacing(10),
        color: theme.palette.secondary.main,
    },
    actHealthColor: {
        color: theme.palette.actHealth.main,
    },
    backToLoginWrapper: {
        marginTop: theme.spacing(8),
        textAlign: 'center',
    },
}));
